import React from 'react';

const DEFAULT_PRODUCT_TAG_COLOR = '#fff';
const DEFAULT_PRODUCT_TAG_BACKGROUND = '#6B3389';

export const ProductTag = ({ name, icon, fontColor, backgroundColor }) => (
    <div
        className="product-tag"
        style={{
            color: fontColor ? fontColor : DEFAULT_PRODUCT_TAG_COLOR,
            backgroundColor: backgroundColor ? backgroundColor : DEFAULT_PRODUCT_TAG_BACKGROUND,
        }}
    >
        {name ? name.toUpperCase() : ''}
        <img className="product-tag__icon" src={`../../../../../img/theme/icons/${icon}`} alt={name} />
    </div>
);
